module.exports = __webpack_public_path__ + "img/5.4a440524.jpg";